import angular from 'angular';
import '@uirouter/angularjs';
import FrSelect from '@front10/healthcare-book/src/app/common/select/select.module';
import FrButton from '@front10/healthcare-book/src/app/common/button/button.module';
import '../../node_modules/bootstrap/scss/bootstrap.scss';
import '@front10/healthcare-book/src/themes/index.scss';

import MenuModule from '../menu/menu.module';
import SearchAppointment from '../health-care-book/search-appointment/search-appointment.module';
import HealthcarebookHomme from '../health-care-book/home/home.module';
import HealthcarebookResponsive from '../health-care-book/responsive/responsive.module';
import HealthcarebookLanguage from '../health-care-book/language/language.module';
import HealthcarebookComponents from '../health-care-book/components/components.module';
import LanguageModule from '../language/language.module';

import './app.css';

import menu from '../config/menu';
import routes from '../config/routes';
import languages from '../config/languages';
import themes from '../config/themes';

let app = () => {
    return {
        template: require('./app.html'),
        controller: 'AppController',
        controllerAs: "$ctrl"
    }
};

class AppController {
    constructor($timeout, $interval, $state) {
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$state = $state;
    }

    $onInit() {
        this.menu = menu;
        this.aviableLanguages = languages;
        this.aviableThemes = themes;
        this.currentTheme = 0;
        this.slidePaused = false;
        if (localStorage) {
            this.selectedTheme = this.findTheme(localStorage.getItem('theme'));
            this.changeTheme({theme: this.selectedTheme});
            this.selectedLanguage = this.findLanguage(localStorage.getItem('languaje'));
            this.slidePaused = localStorage.getItem('paused') === "true";
        }
        this.showSideMenu = false;
        this.showLanguageMenu = false;
        this.currentRoute = 0;
        this.initMenuCounter();
    }

    initMenuCounter() {
        this.counter = localStorage.getItem('counter');
        this.$interval(() => {
            if (!this.slidePaused) {
                this.counter++;
                if (this.counter > 101) {
                    this.counter = 0;
                    this.currentRoute++;
                    if (this.currentRoute >= routes.length)
                        this.currentRoute = 0;
                    this.changeRoute();
                }
                if (localStorage)
                    localStorage.setItem('counter', this.counter);
            }
        }, 50);
    }

    onChangeLanguage({languaje}) {
        this.selectedLanguage = languaje;
        if (localStorage)
            localStorage.setItem('languaje', this.selectedLanguage.id);
        this.showLanguageMenu = false;
        window.location.reload();
    }

    onCloseLanguajeSideBar() {
        this.showLanguageMenu = false;
    }

    changeRoute() {
        let route = routes[this.currentRoute] || routes[0];
        if (route)
            this.$state.go(route.name);
    }

    findRoute(name) {
        let index = 0;
        routes.map((item, i) => {
            if (name === item.name)
                index = i;
            return item;
        });
        return index;
    }

    findLanguage(lang) {
        let language = this.aviableLanguages[0];
        this.aviableLanguages.map((item, i) => {
            if (lang === item.id)
                language = item;
            return item;
        });
        return language;
    }

    findTheme(theme) {
        let them = this.aviableThemes[0];
        this.aviableThemes.map((item, i) => {
            if (theme === item.id) {
                them = item;
                this.currentTheme = i;
            }
            return item;
        });
        return them;
    }

    changeMenuRoute({route}) {
        this.currentRoute = this.findRoute(route.url);
        this.counter = 0;
        this.showSideMenu = false;
    }

    changeTheme() {
        if (!this.aviableThemes[this.currentTheme]) {
            this.currentTheme = 0;
        }
        this.selectedTheme = this.aviableThemes[this.currentTheme];
        document.querySelector("body").setAttribute("theme", this.selectedTheme.id);
        if (localStorage)
            localStorage.setItem('theme', this.selectedTheme.id);
        this.currentTheme++;
    }

    toggleMenu($event, show) {
        if (show)
            this.$timeout(() => {
                this.showSideMenu = true;
            });
        else
            this.showSideMenu = false;
    }

    onChangeStatus({paused}) {
        this.slidePaused = paused;
        if (localStorage)
            localStorage.setItem('paused', paused);
    }
}

export default angular.module('app', ['ui.router', MenuModule, SearchAppointment, FrSelect, FrButton, HealthcarebookHomme, LanguageModule, HealthcarebookResponsive, HealthcarebookLanguage, HealthcarebookComponents])
    .config(($stateProvider, $urlRouterProvider) => {
        $urlRouterProvider.otherwise('/healthcarebook/searchappointment');
        routes.map(route => {
            if (route.name) {
                let conf = {};
                conf.name = route.name;

                if (route.url)
                    conf.url = route.url;
                if (route.template)
                    conf.template = route.template;
                if (route.templateUrl)
                    conf.templateUrl = route.templateUrl;
                if (route.component)
                    conf.template = `<${route.component}></${route.component}>`;

                $stateProvider.state(conf);
            } else
                angular.warn("Route with out name");
        });
    })
    .directive('app', app)
    .controller('AppController', AppController)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/app/app.js
// module id = 641
// module chunks = 0